<template>
    <div class="intermediaries">
        <div class="pr-4 border-b-4 border-default-blue-green mx-4">
            <div class="text-lg font-bold" data-cy="intermediaries-title">
                {{ $t('company.intermediaries.title') }}
            </div>
        </div>
        <div v-if="section_type != 'admin'" class="flex flex-col m-4">
            <div v-if="company_id == null || company_id == ''" class="mb-1" data-cy="intermediary-no-insurer">
                {{ $t('company.intermediaries.insurer-not-selected') }}
            </div>
            <div
                class="lg:w-1/3 w-full lg:pr-2"
                v-if="section_type == 'association_admin'"
                data-cy="intermediary-company-filter"
            >
                <a-select
                    show-search
                    :placeholder="$t('company.intermediaries.insurer-select')"
                    style="width: 100%"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @focus="onfocus"
                    @change="handleCompanyFilterChange"
                    :allowClear="true"
                >
                    <a-select-option v-for="(value, index) in company_list" :key="index" :value="index">
                        {{ value.company_name }}
                    </a-select-option>
                </a-select>
            </div>
            <div
                class="lg:w-1/3 w-full pt-4 lg:pt-0 lg:pr-2"
                v-if="section_type == 'site_admin'"
                data-cy="intermediary-company-filter"
            >
                <a-select
                    show-search
                    :placeholder="$t('company.intermediaries.insurer-select')"
                    style="width: 100%"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @focus="onfocus"
                    @change="handleAssociationFilterChange"
                    :allowClear="true"
                >
                    <a-select-option v-for="(value, index) in company_association_list" :key="index" :value="index">
                        {{ value.association_code }} - {{ value.company_name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div
            v-if="
                company_id != null &&
                ((section_type == 'admin' &&
                    company.authorized_intermediary_id != null &&
                    company.authorized_intermediary_id != '') ||
                    section_type != 'admin')
            "
        >
            <Intermediaries-table
                :company_id="company_id"
                :is_edit="is_edit"
                @is_edit="setEdit"
                ref="IntermediariesTable"
            />
            <div class="flex flex-row justify-end m-8 mb-4 items-center" v-if="is_edit">
                <a-button class="ml-8" data-cy="reset-btn" @click="resetIntermediaries">
                    {{ $t('company.intermediaries.tables.buttons.reset-btn') }}
                </a-button>
                <a-button class="ml-2" type="primary" data-cy="save-btn" @click="saveIntermediaries">
                    {{ $t('company.intermediaries.tables.buttons.save-btn') }}
                </a-button>
            </div>
        </div>
        <div v-if="section_type == 'admin' && company.authorized_intermediary_id == ''" class="mx-4">
            {{ $t('company.intermediaries.authorized-intermediary-id-not-set') }}
        </div>
    </div>
</template>

<script>
import IntermediariesTable from '@/components/tables/Intermediaries.vue';

export default {
    components: {
        IntermediariesTable,
    },
    props: {
        section_type: {
            type: String,
            default: 'admin',
        },
        company: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            is_edit: false,
            company_id: null,
            default_value: '',
            filter_value: '',
            company_list: [],
            company_association_list: [],
        };
    },
    mounted() {
        if (this.section_type == 'site_admin') {
            this.$http
                .get('/api/admin/list-companies-by-associations-insurers')
                .then((response) => {
                    this.company_association_list = response.data.data;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CIAI04' }),
                    });
                });
        } else if (this.section_type == 'association_admin') {
            this.$http
                .get('/api/admin/list-companies-insurers', {
                    params: {
                        association_id: this.$store.getters['user/currentAssociationId'],
                    },
                })
                .then((response) => {
                    this.company_list = response.data.data;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CIAI03' }),
                    });
                });
        } else if (this.section_type == 'admin') {
            this.company_id = this.$route.params.id;
            this.fetch();
        }
    },
    methods: {
        resetIntermediaries() {
            if (this.is_edit) {
                let vm = this;
                this.$confirm({
                    title: this.$t('company.intermediaries.intermediary_reset_modal.title'),
                    content: this.$t('company.intermediaries.intermediary_reset_modal.content'),
                    onOk() {
                        vm.$refs.IntermediariesTable.fetch();
                    },
                    onCancel() {
                        return false;
                    },
                });
            }
        },
        saveIntermediaries() {
            this.$refs.IntermediariesTable.loading = true;

            let params = {
                assigned_intermediaries: this.$refs.IntermediariesTable.assigned.data.map((intermediary) => {
                    return {
                        ...intermediary,
                        is_print_certificate: intermediary.is_print_certificate ? 1 : 0,
                        is_print_covernote: intermediary.is_print_covernote ? 1 : 0,
                    };
                }),
            };

            this.$http
                .post('/api/intermediaries/' + this.company_id + '/update', params)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$notification.success({
                            message: response.data.message,
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CIAI02' }),
                        });
                    }
                })
                .finally(() => {
                    this.$refs.IntermediariesTable.loading = false;
                    this.is_edit = false;
                });
        },
        onfocus() {
            if (this.company_id != null) {
                if (this.is_edit) {
                    let vm = this;
                    this.$confirm({
                        title: this.$t('company.intermediaries.insurers_nav_modal.title'),
                        content: this.$t('company.intermediaries.insurers_nav_modal.content'),
                        onOk() {
                            vm.is_edit = false;
                        },
                        onCancel() {
                            return false;
                        },
                    });
                }
            }
        },
        handleCompanyFilterChange(value) {
            if (value == undefined || value == null) {
                this.company_id = null;
                return false;
            }
            this.company_id = this.company_list[value].company_id;
            this.fetch();
        },
        handleAssociationFilterChange(value) {
            if (value == undefined || value == null) {
                this.company_id = null;
                return false;
            }
            this.company_id = this.company_association_list[parseInt(value)].company_id;
            this.fetch();
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        handleFilterSearch(value) {
            this.filter_value = value;
        },
        fetch() {
            this.$http
                .get('/api/companies/' + this.company_id)
                .then((response) => {
                    this.authorized_intermediary_id = response.authorized_intermediary_id;
                    this.$refs.IntermediariesTable.fetch();
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'not-found',
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CIAI05' }),
                        });
                    }
                });
        },
        setEdit(value) {
            this.is_edit = value;
        },
        reload() {
            if (typeof this.$refs.IntermediariesTable != 'undefined') {
                this.$refs.IntermediariesTable.reload();
            }
        },
    },
};
</script>
